// extracted by mini-css-extract-plugin
export default {"root":"root--dhc2X","switcher":"switcher--ogaWP"};